import { Injectable } from "@angular/core";
import { CuestionarioSaludColectivo } from "../app.domain.models/cuestionario-salud-colectivo";
import { CuestionarioSaludColectivoRepository } from "../app.domain.repository/cuestionario-salud-colectivo.repository";
import { GenericEntityService } from "../core.utilidades/generic-entity.service";


@Injectable({
    providedIn: 'root',
})
export class CuestionarioSaludColectivoApiService extends CuestionarioSaludColectivoRepository implements GenericEntityService<CuestionarioSaludColectivo> { }